import { render } from "./JigyouhiSettingItem.vue?vue&type=template&id=2381ab68&ts=true"
import script from "./JigyouhiSettingItem.vue?vue&type=script&lang=ts"
export * from "./JigyouhiSettingItem.vue?vue&type=script&lang=ts"

import "./JigyouhiSettingItem.vue?vue&type=style&index=0&id=2381ab68&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__